import logo from '../../assets/helthyLogo.png'

export const Logo = (): JSX.Element => {
  return <img src={logo} width="auto" height="70" alt="" id="LogoHelthy" />
}
